import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    Tooltip,
    LabelList,
    ResponsiveContainer,
    Cell,
    Line,
    CartesianGrid,
    Legend
} from "recharts";

const ByCompetenceBarChartIndividual = ({ data = [], redLight = 60, yellowLight = 80 }) => {
    if (!data || data.length === 0) return null;

    const LABEL_RIGHT_MARGIN = 72;

    // Color dinámico para barras
    const getColor = (value) => {
        if (value <= redLight) return "#e53935"; // rojo
        if (value <= yellowLight) return "#fbc02d"; // amarillo
        return "#43a047"; // verde
    };

    const renderAverageLabel = ({ x, y, width, height, value, index }) => {
        const num = Number(value);
        if (!Number.isFinite(num)) return null;

        return (
            <text
                x={x + width + 8}
                y={y + height / 2}
                dy={4}
                textAnchor="start"
                fill="#334155"
                fontWeight={700}
                fontSize={12}
            >
                {num.toFixed(1)}
            </text>
        );
    };

    // Formateo de tooltip
    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const { question } = payload[0].payload; // 👈 extraemos la pregunta del objeto original
            return (
                <div
                    style={{
                        backgroundColor: "white",
                        padding: 10,
                        border: "1px solid #ccc",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        maxWidth: 400
                    }}
                >
                    <strong>{question}</strong> {/* 👈 mostramos la pregunta en lugar del label */}
                    {payload.map((p, idx) => (
                        <span key={idx} style={{ color: p.color }}>
                            {p.name}: {p.value.toFixed(1)}
                        </span>
                    ))}
                </div>
            );
        }
        return null;
    };

    return (
        <ResponsiveContainer width="100%" height={data.length > 10 ? data.length * 30 : data.length * 40}>
            <BarChart
                data={data}
                layout="vertical"
                margin={{ top: 10, right: LABEL_RIGHT_MARGIN, left: 10, bottom: 10 }}
            >
                <CartesianGrid horizontal={false} stroke="#dbe4ef" />
                <XAxis
                    type="number"
                    domain={[0, 100]}
                    orientation="top"
                    ticks={[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100]}
                    tickFormatter={(tick) => `${tick}%`}
                    tick={{ fontSize: 9, fill: '#94a3b8' }}
                    tickLine={false}
                    axisLine={false}
                    height={22}
                />
                <YAxis
                    type="category"
                    dataKey="label"
                    width={100}
                    tick={{ fontSize: 11, fill: '#475569' }}
                    tickLine={false}
                    axisLine={false}
                />
                <Tooltip content={<CustomTooltip />} wrapperStyle={{ zIndex: 1000 }} />

                <Legend verticalAlign="bottom" height={36} />

                {/* Barras de promedio individual */}
                <Bar dataKey="average" barSize={14} radius={[0, 8, 8, 0]} name="Promedio Individual" isAnimationActive={false}>
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={getColor(entry.average)} />
                    ))}
                    <LabelList
                        dataKey="average"
                        position="insideRight"
                        content={renderAverageLabel}
                    />
                </Bar>

                {/* Línea con promedio organizacional */}
                <Line
                    type="linear"
                    dataKey="orgAverage"
                    stroke="#3E246B"
                    strokeWidth={2}
                    strokeDasharray="4 4"
                    dot={{ r: 2, fill: "#3E246B", stroke: '#3E246B' }}
                    activeDot={false}
                    isAnimationActive={false}
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    name="Promedio Organización"
                />
            </BarChart>
        </ResponsiveContainer>
    );
};

export default ByCompetenceBarChartIndividual;
